export default __webpack_public_path__ + "static/media/40.8883ac3a.jpg";